export class UploadInvoice {
    fileName: string;
    pdfPath: string;
    customerCodeId: number;
    month: string;
    year: string;
}